import { createFileRoute } from "@tanstack/react-router";
import Auth from "@/pages/Auth";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/auth/callback")({
  head: () => seoHead({ title: "Signing in", noindex: true }),
  component: Auth,
});
